// types
import { DefaultConfigProps } from 'types/config';
import { BRAND_MANUAL } from 'config/brandManual';

// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/transcriptions';
export const HORIZONTAL_MAX_ITEM = 7;
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;
export const BRAND_GOLD = '#C9A227';

type BrandColors = {
  gold: string;
  navy: string;
};

export function getBrandColors(isDark = false): BrandColors {
  return {
    gold: BRAND_GOLD,
    navy: isDark ? BRAND_MANUAL.bluePale : BRAND_MANUAL.dark
  };
}

export enum SimpleLayoutType {
  SIMPLE = 'simple',
  LANDING = 'landing'
}

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark'
}

export enum MenuOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal'
}

export enum ThemeDirection {
  LTR = 'ltr',
  RTL = 'rtl'
}

export enum NavActionType {
  FUNCTION = 'function',
  LINK = 'link'
}

export enum Gender {
  MALE = 'Male',
  FEMALE = 'Female'
}

export enum DropzoneType {
  DEFAULT = 'default',
  STANDARD = 'standard'
}

export enum AuthProvider {
  JWT = 'jwt'
}

export const APP_AUTH: AuthProvider = AuthProvider.JWT;

// ==============================|| THEME CONFIG ||============================== //
/**
 * `presetColor` escolhe a paleta em `src/themes/theme/index.ts` → `theme*.ts`.
 * - `default` — primário = escala azul Ant Design (`presetPalettes.blue`).
 * - `theme1` — monocromático (preto/branco + cinzas; aviso/info/sucesso discretos).
 * - `theme2` — roxo (`Theme2`).
 * - `theme3` … `theme7` — variantes em `src/themes/theme/theme3.ts` … `theme7.ts`.
 * - `theme8` — manual da marca (`/branding`): primário azul Swift via `src/config/brandManual.ts`).
 * O valor deve existir em `PresetColor` (`types/config.ts`); o UI de personalização
 * grava o mesmo identificador no `ConfigContext`.
 */
const config: DefaultConfigProps = {
  fontFamily: `'Merriweather', 'Public Sans', sans-serif`,
  i18n: 'pt-BR',
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: false,
  container: true,
  mode: ThemeMode.LIGHT,
  presetColor: 'theme8',
  themeDirection: ThemeDirection.LTR
};

export default config;
